import axios from "axios";
import {API } from "../API_CONFIG";
export const BASE_URL = API;

export const getProfileDetails = async (accessToken,userFeatures) => {
    var config = {
        method: 'get',
        url: `${BASE_URL.providerNode}/provider/ProfileDetails`,
        headers: {
            'Content-Type': 'application/json',
            accesstoken: accessToken,
            userfeatures: userFeatures
        },
    };
        let response = await axios(config);
        return response;
};